import React from 'react'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from 'reactstrap'
import VisitContext from '../../context/Visit/VisitContext'
import { CustomTooltip } from '../CustomTooltip/CustomTooltip'
import { getUserDataByKey } from '../../helpers/helpers'
import { certificationGet } from '../../services/examService'

export const ValidInductionsList = ({ induction, handleInductionSelected, isAdded, handleModal, handleModalQuestionary, getCallback }) => {

    const { visitState, resetVisitExamAttempts } = useContext(VisitContext);

    const { visitSelected } = visitState;

    const currentDate = new Date();

    const { t } = useTranslation();

    const profile = getUserDataByKey('profile');

    const added = isAdded(induction.induction._id)

    const canReAdd = () => {
        if (induction.date_to) {
            return +currentDate > +new Date(induction.date_to)
        }
        if (induction.sended) {
            return induction.viewed === false && induction.active === true
        }

        return induction.sended === false
    }

    const [loadingExam, setLoadingExam] = useState(false);
    const [examError, setExamError] = useState(false);

    const visitExam = (questions, note) => {
        let questionaryCopy = { ...induction.questionary }
        questionaryCopy.questions = questions
        questionaryCopy.note = note
        questionaryCopy.visit = visitSelected
        return questionaryCopy
    }

    const handleViewExam = async () => {
        if (!induction.exam?.certification) return;
        setLoadingExam(true);
        setExamError(false);
        const resp = await certificationGet(induction.exam.certification);
        setLoadingExam(false);
        if (resp?.ok && resp.data?.questionary) {
            handleModalQuestionary(visitExam(resp.data.questionary.questions, resp.data.questionary.note));
        } else {
            setExamError(true);
        }
    }

    const handleResetAttempts = async () => {
        if (resetVisitExamAttempts) {
            // Enviar ID de visualización y ID de inducción
            const success = await resetVisitExamAttempts(visitSelected._id, induction.induction._id);
            if (success) {
                getCallback();
            }
        }
    }

    return (
        <tr>
            <td>
                {
                    canReAdd() ?
                        <Input
                            type='checkbox'
                            onChange={(e) => handleInductionSelected(e, induction)}
                            checked={added}
                        />
                        :
                        null
                }
            </td>
            <td>
                {induction.induction.name}
            </td>
            <td>
                {induction.questionary ? <>{induction.questionary.name}  (v{induction.questionary.version}.0)</> : '-'}
            </td>
            <td>
                {induction.sended ? t('common.yes') : t('common.no')}
            </td>
            <td>
                {induction.viewed ? t('common.yes') : t('common.no')}
                {
                    induction.date_to && (+currentDate > +new Date(induction.date_to)) ?
                        <>
                            <CustomTooltip
                                placement={"top"}
                                target={`isExpired-${induction.induction._id}`}
                                text={t('inductions.induction_expired')}
                            />
                            <i className="fa-solid fa-circle-exclamation ps-1 text-danger" id={`isExpired-${induction.induction._id}`}></i>
                        </>
                        :
                        null
                }
            </td>
            <td>
                {induction.questionary ? (induction.approved ? t('common.yes') : t('common.no')) : '-'}
            </td>
            <td>
                {
                    induction.exam ?
                        `${induction.exam.note}/${induction.questionary.max_score}` :
                        '-'
                }
            </td>
            <td>
                {
                    induction.exam
                        ?
                        induction.exam.attempts
                        :
                        '-'
                }
            </td>
            <td>{induction.date_from ? induction.date_from.slice(0, 10).split('-').reverse().join('-') : '-'}</td>
            <td>{induction.date_to ? induction.date_to.slice(0, 10).split('-').reverse().join('-') : '-'}</td>
            <td>
                {
                    induction.sended === true && (induction.viewed === false || induction.approved === false) ?
                        <>
                            <CustomTooltip
                                placement={"top"}
                                target={induction.active ? `revoke-${induction.induction._id}` : `grant-${induction.induction._id}`}
                                text={induction.active ? t('common.expire_induction') : t('common.reset_induction')}
                            />
                            <i
                                className={induction.active ? "fa-solid fa-circle-xmark me-3 link-danger" : "fa-solid fa-recycle me-3 link-success me-2"}
                                type='button'
                                id={induction.active ? `revoke-${induction.induction._id}` : `grant-${induction.induction._id}`}
                                onClick={() => handleModal(!induction.active, induction.induction._id)}
                            >
                            </i>
                        </>
                        :
                        null
                }
                {
                    (induction.exam && induction.exam.certification) ?
                        <>
                            <CustomTooltip
                                placement={"top"}
                                target={`detail-${induction.induction._id}`}
                                text={examError ? t('common.error_server') : t('employee.view_exam')}
                            />
                            <i
                                className={loadingExam
                                    ? "fa-solid fa-spinner fa-spin me-2"
                                    : (examError ? "fa-solid fa-triangle-exclamation link-danger me-2" : "fa-solid fa-circle-info me-2")}
                                id={`detail-${induction.induction._id}`}
                                type='button'
                                onClick={loadingExam ? undefined : handleViewExam}
                            >
                            </i>
                        </>
                        :
                        null
                }
                {
                    profile === '01' && !!induction.exam && induction.employee_approved === false && (
                        <>
                            <CustomTooltip
                                placement={"top"}
                                target={`reset-attempts-${induction.induction._id}`}
                                text={t('employee.reset_attemps')}
                            />
                            <i
                                className="fa-solid fa-rotate-left"
                                id={`reset-attempts-${induction.induction._id}`}
                                type='button'
                                onClick={handleResetAttempts}
                            >
                            </i>
                        </>
                    )
                }
            </td>
        </tr>
    )
}